import { getTagDataInfo } from "./itemUtil";

// Request keys the items-search endpoint reserves for itself.
const RESERVED_KEYS = ['tag', 'name', 'filters'];

// POST /api/v1/items-search only applies `name` and filters on `enum`
// properties (as a list of accepted values). Other property types are
// ignored server-side, so they are not offered as filters.
export const SUPPORTED_FILTER_TYPES = ['enum'];

const enumValues = property => {
    const values = Array.isArray(property?.values) ? property.values
        : Array.isArray(property?.options?.values) ? property.options.values
        : [];
    return values.filter(v => v !== null && v !== undefined && v !== '');
}

export const getFilterableProperties = tag =>
    getTagDataInfo(tag)
        .filter(p => p?.name && SUPPORTED_FILTER_TYPES.includes(p.type) && !RESERVED_KEYS.includes(p.name))
        .map(p => ({ name: p.name, type: p.type, values: enumValues(p) }))
        .filter(p => p.values.length > 0);

// Drops filters that don't apply to the tag, unknown values, and empties.
export const sanitizeFilters = (tag, filters) => {
    const result = {};
    if (!filters || typeof filters !== 'object') return result;
    getFilterableProperties(tag).forEach(p => {
        const selected = Array.isArray(filters[p.name]) ? filters[p.name] : [];
        const valid = selected.filter(v => p.values.includes(v));
        if (valid.length) result[p.name] = Array.from(new Set(valid));
    });
    return result;
}

export const buildSearchBody = (tagName, name, filters = {}) => {
    const body = { tag: tagName };
    const trimmed = typeof name === 'string' ? name.trim() : '';
    if (trimmed) body.name = trimmed;
    Object.entries(filters || {}).forEach(([key, values]) => {
        if (RESERVED_KEYS.includes(key)) return;
        if (Array.isArray(values) && values.length) body[key] = values;
    });
    return body;
}

export const countActiveFilters = filters =>
    Object.values(filters || {}).reduce((n, values) => n + (Array.isArray(values) ? values.length : 0), 0);

export const parseFiltersParam = value => {
    if (!value) return {};
    try {
        const parsed = JSON.parse(value);
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch (e) {
        return {};
    }
}

export const serializeFiltersParam = filters => {
    const clean = Object.fromEntries(Object.entries(filters || {}).filter(([, v]) => Array.isArray(v) && v.length));
    return Object.keys(clean).length ? JSON.stringify(clean) : null;
}
